import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { FormServices } from 'src/app/services/form.services';
import { StepDataInterface } from 'src/app/system-utils/side-panel/side-panel.component';
import { AgChartOptions } from 'ag-charts-community';
import { ChartsInterface } from '../../interfaces/charts';
import { DashBoardTypeEnum, GadGetInterface } from '../../interfaces/dashboard';
import { QueryServices } from 'src/app/forms/query-executor/query-executor.component';
import { DashboardViewService } from 'src/app/services/dashboard.services';

/*
 * Aberto via NzModalService.create({ nzData, nzViewContainerRef }) —
 * o nzViewContainerRef do dashboard garante que o DashboardViewService
 * injetado aqui seja A MESMA instância (contexto empresa/contrato).
 */
@Component({
    selector: 'chart-card-configuration',
    templateUrl: './chart-card-configuration.component.html',
    styleUrl: './chart-card-configuration.component.scss',
    standalone: false
})
export class ChartCardConfigurationComponent implements OnInit {

  formFilter: FormGroup;
  form: FormGroup;
  tabName: string;
  name: string;
  idDashboard: number;
  filters: string[];
  fields: string[];
  item: ChartsInterface;
  stepData: StepDataInterface[] = [];
  newGadGet = false;
  buttonList: ButtonList[] = [];

  constructor(
    @Inject(NZ_MODAL_DATA) public dataDialog,
    public modalRef: NzModalRef,
    public formBuilder: FormBuilder,
    public formServices: FormServices,
    public dvs: DashboardViewService,
    private message: NzMessageService,
    private queryServices: QueryServices
  ) {

  }

  onQueryChange($event) {
    this.form.get('query').setValue($event);
    this.item.query = $event;
  }

  get query() {
    return this.form.get('query').value;
  }

  get options() {
    return this.form.get('options');
  }

  get type() {
    return this.form.get('type').value;
  }

  formatJSON() {
    const value = this.options.value;
    try {
      const ob = JSON.parse(value);
      this.options.setValue(JSON.stringify(ob, null, "\t"));
    } catch (error) {
      this.message.error('O JSON da configuração do gráfico é inválido.');
    }
  }

  ngOnInit(): void {

    if (this.dataDialog.item == null) {
      this.newGadGet = true;
    }

    this.item = this.dataDialog.item == null ? {
      title: "",
    } : this.dataDialog.item;

    this.idDashboard = this.dataDialog.idDashBoard;
    this.tabName = this.dataDialog.tabName;
    this.formFilter = this.dataDialog.formFilter;

    this.filters = this.dataDialog.filters != null ? this.dataDialog.filters : [];
    this.dvs.addDefaultFilters(this.filters);

    if (this.name == null) {
      this.name = this.dataDialog.name == null ?
        // enum CHART no nome (bug antigo: gerava com minicard)
        this.idDashboard + "_" + this.tabName + "_" + DashBoardTypeEnum.chart + "_" + Date.now().toString() :
        this.dataDialog.name;
    }

    this.form = this.formBuilder.group({
      title: new FormControl<string>(null, Validators.required),
      options: new FormControl<AgChartOptions>(null, Validators.required),
      query: new FormControl<string>(null),
      refresh: new FormControl<number>(null)
    });

    this.formServices.refreshFormObject(this.form, this.item);

    this.form.get('options').setValue(JSON.stringify(this.item.options, null, "\t"));

    this.buttonList.push({
      color: "warn",
      description: "Cancelar",
      action: () => {
        this.sair();
      }
    },
      {
        color: "primary",
        description: "Salvar",
        action: () => {
          this.okFunction();
        }
      });

    this.stepData = [
      {
        buttonList: this.buttonList,
        name: "Nome",
        sideDesc: "Informações",
        title: "Informações",

      },
      {
        buttonList: this.buttonList,
        name: "query",
        sideDesc: "Query",
        title: "Consulta ao Banco de Dados",

      },
      {
        buttonList: this.buttonList,
        name: "advanced",
        sideDesc: "Avançado",
        title: "Configuração do Gráfico",
      }
    ];
  }

  /** valida o JSON das options ANTES de fechar — nunca persiste JSON inválido */
  private parseOptions(): AgChartOptions | null {
    try {
      const raw = (this.options.value as string) ?? '';
      return JSON.parse(raw.replace(/\\n/gi, "").replace(/\\t/gi, "").replace(/\\r/gi, ""));
    } catch {
      return null;
    }
  }

  okFunction() {
    if (this.form.valid) {

      const options = this.parseOptions();
      if (options == null) {
        this.message.error('A configuração do gráfico (Avançado) não é um JSON válido.');
        return;
      }

      if (this.newGadGet) {
        const val: object = JSON.parse(JSON.stringify(this.form.getRawValue()));
        val['options'] = options;

        const data: ChartsInterface = JSON.parse(JSON.stringify(val));

        const gadget: GadGetInterface = {
          gridsterItem: {
            cols: 1,
            rows: 1,
            x: 0,
            y: 0
          },
          name: this.name,
          type: DashBoardTypeEnum.chart,
          chart: data
        };

        this.modalRef.close(gadget);

      } else {
        const data: ChartsInterface = JSON.parse(JSON.stringify(this.form.getRawValue())) as ChartsInterface;
        data['options'] = options;
        this.item = data;
        this.modalRef.close(this.item);
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  sair() {
    this.modalRef.close();
  }

  loadQuery() {
    let executeQuery = null;
    if (this.formFilter != null) {
      executeQuery = this.dvs.applyFilters(this.item.query, this.formFilter);
    } else {
      executeQuery = this.item.query;
    }
    this.queryServices.findNative(executeQuery, true, 1).then((data: Object[]) => {
      const ob: Object = (data as Object[])[0];
      if (ob != null) {
        this.fields = Object.keys(ob);
      }
    });
  }

}
